// components/ProductLabelChips.jsx

import { mediaUrl } from "@/lib/config/app"; // adjust import path if your project exposes mediaUrl differently

const TEXT_POSITION_CLASSES = {
  'top-left': 'absolute top-2 left-2 items-start',
  'top-right': 'absolute top-2 right-2 items-end',
  'top-center': 'absolute top-1 left-1/2 -translate-x-1/2 items-center w-95/100',
  'bottom-left': 'absolute bottom-2 left-2 items-start',
  'bottom-right': 'absolute -bottom-1 -right-0.5 items-end',
  'bottom-center': 'absolute bottom-0 left-1/2 -translate-x-1/2 items-center w-95/100',
  'inline': 'static items-start'
};
const IMAGE_POSITION_CLASSES = {
  'top-left': 'absolute -top-1 left-0 items-start',
  'top-right': 'absolute top-0 right-0 items-end',
  'top-center': 'absolute top-0 left-1/2 -translate-x-1/2 items-center',
  'bottom-left': 'absolute bottom-0 left-0 items-start',
  'bottom-right': 'absolute bottom-0 right-0 items-end',
  'bottom-center': 'absolute bottom-0 left-1/2 -translate-x-1/2 items-center',
  'inline': 'static items-start'
};
const DEFAULT_BG = '#111827';
const DEFAULT_TEXT = '#ffffff';
function chipStyle(l) {
  const bg = l.bg_color || DEFAULT_BG;
  const text = l.color || DEFAULT_TEXT;
  if (l.style === 'outline') {
    return {
      backgroundColor: 'transparent',
      color: bg,
      border: `1.5px solid ${bg}`
    };
  }
  return {
    backgroundColor: bg,
    color: text,
    ...(l.style === 'ribbon' ? {
      transform: 'skewX(-4deg)',
      boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
    } : {})
  };
}
function textShapeClasses(position, isFirst) {
  if (position === 'bottom-center') {
    return 'w-full text-xs lg:text-sm text-center';
  }
  if (position === 'top-center') {
    return `w-full text-xs lg:text-sm text-center ${isFirst ? 'rounded' : ''}`;
  }
  return 'w-fit text-xs rounded';
}
function groupByPosition(items) {
  return items.reduce((acc, l) => {
    const pos = l.position || 'top-left';
    (acc[pos] ||= []).push(l);
    return acc;
  }, {});
}
export default function ProductLabelChips({
  labels = []
}) {
  if (!labels.length) return null;
  const imageItems = labels.filter(l => l.image);
  const textItems = labels.filter(l_0 => l_0.use_label && l_0.label);
  const imageGroups = groupByPosition(imageItems);
  const textGroups = groupByPosition(textItems);
  const groups = labels.reduce((acc, l_1) => {
    const pos = l_1.position || 'top-left';
    (acc[pos] ||= []).push(l_1);
    return acc;
  }, {});
  return <>
            {Object.entries(imageGroups).map(([position, group]) => <div key={`img-${position}`} className={`flex flex-col gap-1 z-3 ${IMAGE_POSITION_CLASSES[position] ?? IMAGE_POSITION_CLASSES['top-left']}`}>
                    {group.map(l_2 => <img key={`${l_2.kind}-${l_2.id}`} src={`${mediaUrl}${l_2.image}`} alt={l_2.label || ''} className="aspect-square max-w-12 max-h-12 object-contain" />)}
                </div>)}

            {Object.entries(textGroups).map(([position_0, group_0]) => <div key={`text-${position_0}`} className={`flex flex-col gap-1 z-3 ${TEXT_POSITION_CLASSES[position_0] ?? TEXT_POSITION_CLASSES['top-left']}`}>
                    {group_0.map((l_3, idx) => <span key={`${l_3.kind}-${l_3.id}`} className={`font-medium px-2 py-0.5 ${textShapeClasses(position_0, idx === 0)}`} style={chipStyle(l_3)}>
                            {l_3.label}
                        </span>)}
                </div>)}

        </>;
}